import config from '../../../../config';

import PaymentMethod from './PaymentMethod';
import PaymentMethodLoyaltyEnabled from './PaymentMethodLoyaltyEnabled';

export default config?.FF_LOYALTY_ENABLED
  ? PaymentMethodLoyaltyEnabled
  : PaymentMethod;
